import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record } from "immutable";

export const emailEventFromJSON = (json: Partial<IEmailEvent>): EmailEventRecord => {
  const record: IEmailEventRecord = { ...(json as any) };

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new EmailEventRecord(record);
};

export interface IEmailEvent {
  id: number;
  recipient: string;
  record_type: string;
  sub_type: number;
  happened_at: Date;
  description: string;
  email_id: number;
  updated_at: Date;
  created_at: Date;
}

export interface IEmailEventRecord {
  id: number;
  recipient: string;
  record_type: string;
  sub_type: number;
  happened_at: Nullable<Date>;
  description: string;
  email_id: number;
  updated_at: Nullable<Date>;
  created_at: Nullable<Date>;
}

export const defaultEmailEventProps: IEmailEventRecord = {
  id: 0,
  recipient: "",
  record_type: "",
  sub_type: 0,
  happened_at: null,
  description: "",
  email_id: 0,
  updated_at: null,
  created_at: null,
};

export class EmailEventRecord extends Record(defaultEmailEventProps) implements IEmailEventRecord {}
